import { render, staticRenderFns } from "./EditNotifyPhone.vue?vue&type=template&id=4c46f0e4&scoped=true&"
import script from "./EditNotifyPhone.vue?vue&type=script&lang=js&"
export * from "./EditNotifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./EditNotifyPhone.vue?vue&type=style&index=0&id=4c46f0e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46f0e4",
  null
  
)

export default component.exports